<template>
  <div v-if="errorMessage !== null">
    <div class="container">
      <h1 class="review-title">
        {{ errorMessage }}
      </h1>
    </div>
  </div>
  <div v-else-if="exists === false">
    <div class="container">
      <div v-if="!confirmedRating">
        <div v-if="!isLockerOrder">
          <h1 class="review-title">{{ $t('reviewBody.rateExperience') }}</h1>
          <h2 class="star-title">{{ $t('reviewBody.deliveryQuestion') }}</h2>
          <div @mouseleave="onRatingHover(null)" style="display: inline-block">
            <star-rating
              class="star-rating"
              :show-rating="false"
              :rounded-corners="true"
              :star-size="58"
              active-color="#f68b24"
              @current-rating="onRatingHover"
              @rating-selected="setRating"
            ></star-rating>
          </div>
          <p class="rating-explanation" v-if="hoveredRating !== null">
            {{ ratingExplanation[hoveredRating] }}
          </p>
          <p class="rating-explanation" v-else-if="rating !== null">
            {{ ratingExplanation[rating] }}
          </p>
          <div class="button-container">
            <button
              v-on:click="confirmRating"
              :disabled="isDisabled"
              class="button-next"
              type="button"
              value="submit"
            >
              <Span>{{ $t('reviewBody.nextButton') }}</Span>
            </button>
          </div>
        </div>
        <div v-else>
          <h1 class="review-title">{{ $t('reviewBody.rateExperience') }}</h1>
          <h2 class="star-title">
            {{ $t('reviewBody.lockerQuestionPre') }}<br />{{ $t('reviewBody.lockerQuestionMid') }}
            <span class="bold-text">Skroutz Points</span> {{ $t('reviewBody.lockerQuestionPost') }}
          </h2>
          <br />
          <br />
          <br />
          <br />
          <br v-if="!isLargeScreen" />
          <br v-if="!isLargeScreen" />
          <br v-if="!isLargeScreen" />

          <div @mouseleave="onRatingHover(null)" style="display: inline-block">
            <div class="rating-container">
              <div
                class="circle"
                v-for="value in ratingScale"
                :key="value"
                :data-value="value"
                @mouseover="onRatingHover(value)"
                @click="setRating(value)"
                :class="{ selected: rating !== null && rating >= value }"
              >
                {{ value }}
              </div>
            </div>
          </div>
          <p class="rating-explanation" v-if="hoveredRating !== null">
            {{ ratingExplanation[hoveredRating] }}
          </p>
          <p class="rating-explanation" v-else-if="rating !== null">
            {{ ratingExplanation[rating] }}
          </p>
          <div class="button-container">
            <button
              v-on:click="confirmRating"
              :disabled="isDisabled"
              class="button-next"
              type="button"
              value="submit"
            >
              <Span>{{ $t('reviewBody.nextButton') }}</Span>
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="!isLockerOrder">
          <div
            v-if="
              confirmedTipSelection === true ||
                (rating !== null && rating > 3 && countryCode === 'CY') ||
                (rating !== null && rating <= 3 && countryCode === 'CY' && confirmedSend === true)
            "
          >
            <h1 class="review-title">{{ $t('reviewBody.thankYouRating') }}</h1>
            <router-link to="/"
              ><button
                class="button-next"
                type="button"
                value="submit"
                style="background-color: #f68b24"
              >
                <Span>{{ $t('reviewBody.backButton') }}</Span>
              </button></router-link
            >
          </div>
          <div
            v-else-if="
              rating !== null &&
                countryCode != 'CY' &&
                (rating > 3 || confirmedSend === true)
            "
          >
            <h1 class="review-title">
              {{ $t('reviewBody.tipQuestion') }}
            </h1>
            <a
              :href="'https://www.skroutz.gr/tip/' + voucher"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                v-on:click="confirmTipSelection"
                :disabled="isDisabled"
                class="button-next"
                type="button"
                value="submit"
              >
                <Span>{{ $t('reviewBody.yes') }}</Span>
              </button>
            </a>
            <button
              v-on:click="confirmTipSelection"
              :disabled="isDisabled"
              class="button-no"
              type="button"
              value="submit"
            >
              <Span>{{ $t('reviewBody.no') }}</Span>
            </button>

            <div style="margin-top: 15px">
              <h6>
                {{ $t('reviewBody.tipNote') }}
              </h6>
            </div>
          </div>
          <div v-else-if="rating !== null && rating <= 3">
            <div v-if="reviewFeedback === null">
              <h1 class="review-title">
                {{ $t('reviewBody.sorryNegative') }}
              </h1>
              <h2 class="star-title">{{ $t('reviewBody.improvementQuestion') }}</h2>
              <div>
                <button
                  v-on:click="onFeedback('delivery time')"
                  class="button-next feedback-button"
                  type="button"
                  value="delivery-time"
                  style="background-color: #f68b24"
                >
                  <Span>{{ $t('reviewBody.feedbackDeliveryTime') }}</Span>
                </button>
                <button
                  v-on:click="onFeedback('delivery location')"
                  class="button-next feedback-button"
                  type="button"
                  value="delivery-location"
                  style="background-color: #f68b24"
                >
                  <Span>{{ $t('reviewBody.feedbackDeliveryLocation') }}</Span>
                </button>
              </div>
              <div>
                <button
                  v-on:click="onFeedback('driver conduct')"
                  class="button-next feedback-button"
                  type="button"
                  value="driver-conduct"
                  style="background-color: #f68b24"
                >
                  <Span>{{ $t('reviewBody.feedbackDriverConduct') }}</Span>
                </button>
                <button
                  v-on:click="onFeedback('other')"
                  class="button-next feedback-button"
                  type="button"
                  value="other"
                  style="background-color: #f68b24"
                >
                  <Span>{{ $t('reviewBody.feedbackOther') }}</Span>
                </button>
              </div>
            </div>
            <div v-else-if="reviewFeedback !== null && confirmedSend !== true">
              <h1 class="review-title">
                {{ $t('reviewBody.sorryNegative') }}
              </h1>
              <h2 class="star-title feedback-text">
                {{ $t('reviewBody.feedbackPrompt') }}
              </h2>
              <textarea
                autofocus
                maxlength="500"
                v-model="feedbackMessage"
                :placeholder="$t('reviewBody.feedbackPlaceholder')"
              ></textarea>
              <div>
                <button
                  v-on:click="onFeedbackComment(feedbackMessage)"
                  class="button-next"
                  :disabled="isDisabledSend"
                  type="button"
                  value="submit"
                >
                  <Span>{{ $t('reviewBody.sendButton') }}</Span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="confirmedSend === true">
            <h1 class="review-title">{{ $t('reviewBody.thankYouTime') }}</h1>
            <router-link to="/"
              ><button
                class="button-next"
                type="button"
                value="submit"
                style="background-color: #f68b24"
              >
                <Span>{{ $t('reviewBody.backButton') }}</Span>
              </button></router-link
            >
          </div>
          <div v-else-if="rating !== null && rating >= 9">
            <div v-if="reviewFeedback === null">
              <h1 class="review-title">
                {{ $t('reviewBody.happyExperience') }}
              </h1>
              <h2 v-if="isLargeScreen" class="star-title">
                {{
                  isReturn === true
                    ? $t('reviewBody.lockerLikedReturnLarge')
                    : $t('reviewBody.lockerLikedPickupLarge')
                }}
              </h2>
              <h2 v-else class="star-title">
                {{ $t('reviewBody.lockerLikedPre') }} <br />
                {{
                  isReturn === true
                    ? $t('reviewBody.lockerLikedReturnPost')
                    : $t('reviewBody.lockerLikedPickupPost')
                }}
              </h2>
              <textarea
                autofocus
                maxlength="500"
                v-model="feedbackMessage"
                :placeholder="$t('reviewBody.impressionsPlaceholder')"
              ></textarea>
              <div>
                <button
                  v-on:click="onFeedback(feedbackMessage)"
                  class="button-next"
                  :disabled="isDisabledSend"
                  type="button"
                  value="submit"
                >
                  <Span>{{ $t('reviewBody.sendButton') }}</Span>
                </button>
              </div>
            </div>
          </div>
          <div v-else-if="rating !== null && rating < 9">
            <div v-if="reviewFeedback === null">
              <div v-if="rating < 9 && rating >= 6">
                <h1 class="review-title">
                  {{ $t('reviewBody.happyExperience') }}
                </h1>
                <h2 v-if="isLargeScreen" class="star-title">
                  {{ $t('reviewBody.improveSuggestionLarge') }}
                </h2>
                <h2 v-else class="star-title">
                  {{ $t('reviewBody.improveSuggestionPre') }} <br />
                  {{ $t('reviewBody.improveSuggestionPost') }}
                </h2>
                <div v-if="!isLargeScreen">
                  <br />
                  <br />
                </div>
              </div>

              <div v-else>
                <h1 class="review-title">
                  {{ $t('reviewBody.sorryNegative') }}
                </h1>
                <h2 class="star-title">{{ $t('reviewBody.whatDidntYouLike') }}</h2>
              </div>
              <div>
                <button
                  v-on:click="onFeedback('bad instractions')"
                  class="button-next"
                  type="button"
                  value="bad-instractions"
                  style="background-color: #f68b24"
                >
                  <Span v-if="isLargeScreen">{{
                    isReturn === true
                      ? $t('reviewBody.feedbackReturnInstructions')
                      : $t('reviewBody.feedbackPickupInstructions')
                  }}</Span>
                  <Span v-else>{{
                    isReturn === true
                      ? $t('reviewBody.feedbackReturnInstructions')
                      : $t('reviewBody.feedbackPickupInstructions')
                  }}</Span>
                </button>
                <button
                  v-on:click="onFeedback('more time in')"
                  class="button-next"
                  type="button"
                  value="more-time-in"
                  style="background-color: #f68b24"
                >
                  <Span v-if="isLargeScreen">{{
                    isReturn === true
                      ? $t('reviewBody.feedbackLockerTimeReturn')
                      : $t('reviewBody.feedbackLockerTimePickup')
                  }}</Span>
                  <Span v-else>{{
                    isReturn === true
                      ? $t('reviewBody.feedbackLockerTimeReturn')
                      : $t('reviewBody.feedbackLockerTimePickup')
                  }}</Span>
                </button>
              </div>
              <div>
                <button
                  v-on:click="onFeedback('bad location')"
                  class="button-next"
                  type="button"
                  value="bad-location"
                  style="background-color: #f68b24"
                >
                  <Span v-if="isLargeScreen">{{ $t('reviewBody.feedbackLockerLocation') }}</Span>
                  <Span v-else>{{ $t('reviewBody.feedbackLockerLocation') }}</Span>
                </button>
                <button
                  v-on:click="onFeedback('custom')"
                  class="button-next"
                  type="button"
                  value="custom"
                  style="background-color: #f68b24"
                >
                  <Span v-if="isLargeScreen">{{ $t('reviewBody.feedbackSomethingElse') }}</Span>
                  <Span v-else>{{ $t('reviewBody.feedbackSomethingElse') }}</Span>
                </button>
              </div>
            </div>
            <div
              v-else-if="
                reviewFeedback === 'custom' ||
                  reviewFeedback === 'bad instractions' ||
                  reviewFeedback === 'bad location'
              "
            >
              <div v-if="rating < 9 && rating > 5">
                <h1 class="review-title">
                  {{ $t('reviewBody.happyExperience') }}
                </h1>
              </div>
              <div v-else>
                <h1 class="review-title">
                  {{ $t('reviewBody.sorryNegative') }}
                </h1>
              </div>
              <h2 class="star-title">{{ $t('reviewBody.improvementQuestion') }}</h2>
              <textarea
                autofocus
                maxlength="500"
                v-model="feedbackMessage"
                :placeholder="$t('reviewBody.feedbackPlaceholder')"
              ></textarea>
              <div>
                <button
                  v-on:click="onFeedback(feedbackMessage)"
                  class="button-next"
                  :disabled="isDisabledSend"
                  type="button"
                  value="submit"
                >
                  <Span>{{ $t('reviewBody.sendButton') }}</Span>
                </button>
              </div>
            </div>
            <div v-else-if="confirmedSend === true">
              <div class="container">
                <h1 class="review-title">
                  {{ $t('reviewBody.thankYouTime') }}
                </h1>
                <router-link to="/"
                  ><button
                    class="button-next"
                    type="button"
                    value="submit"
                    style="background-color: #f68b24"
                  >
                    <Span>{{ $t('reviewBody.backButton') }}</Span>
                  </button></router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="exists === true">
    <div class="container">
      <h1 class="review-title">{{ $t('reviewBody.thankYouRating') }}</h1>
      <router-link to="/"
        ><button class="button-next" type="button" value="submit" style="background-color: #f68b24">
          <Span>{{ $t('reviewBody.backButton') }}</Span>
        </button></router-link
      >
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating';
import axios from 'axios';
export default {
  name: 'ReviewBody',
  components: {
    StarRating,
  },
  props: {
    exists: {
      type: Boolean,
      required: true,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    voucher: {
      type: String,
      required: true,
    },
    isLockerOrder: {
      type: Boolean,
      required: true,
    },
    isReturn: {
      type: Boolean,
      required: true,
    },
    countryCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ratingScale: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      rating: null,
      reviewOption: '',
      hoveredRating: null,
      confirmedRating: false,
      confirmedTipSelection: false,
      reviewFeedback: null,
      feedbackMessage: '',
      confirmedSend: false,
      ratingExplanation: this.isLockerOrder
        ? {
            1: this.$t('reviewBody.lockerRating1'),
            2: this.$t('reviewBody.lockerRating2'),
            3: this.$t('reviewBody.lockerRating3'),
            4: this.$t('reviewBody.lockerRating4'),
            5: this.$t('reviewBody.lockerRating5'),
            6: this.$t('reviewBody.lockerRating6'),
            7: this.$t('reviewBody.lockerRating7'),
            8: this.$t('reviewBody.lockerRating8'),
            9: this.$t('reviewBody.lockerRating9'),
            10: this.$t('reviewBody.lockerRating10'),
          }
        : {
            1: this.$t('reviewBody.rating1'),
            2: this.$t('reviewBody.rating2'),
            3: this.$t('reviewBody.rating3'),
            4: this.$t('reviewBody.rating4'),
            5: this.$t('reviewBody.rating5'),
          },
      isLargeScreen: false, // Adjust the breakpoint as needed
    };
  },
  computed: {
    isDisabled() {
      return this.rating === null;
    },

    isDisabledSend() {
      return this.feedbackMessage === null || this.feedbackMessage.length < 1;
    },

    hasFinishedReviewing() {
      if (this.rating === null) {
        return false;
      } else if (
        (this.rating > 3 &&
          this.confirmedRating === true &&
          this.isLockerOrder !== true &&
          this.countryCode === 'CY') ||
        (this.rating > 3 &&
          this.confirmedRating === true &&
          this.confirmedTipSelection === true &&
          this.isLockerOrder !== true &&
          this.countryCode !== 'CY') ||
        (this.rating >= 9 &&
          this.confirmedRating === true &&
          this.confirmedSend === true &&
          this.isLockerOrder === true)
      ) {
        return true;
      } else if (
        (this.rating <= 3 &&
          this.confirmedSend === true &&
          this.isLockerOrder !== true &&
          this.countryCode === 'CY') ||
        (this.rating <= 3 &&
          this.confirmedSend === true &&
          this.confirmedTipSelection === true &&
          this.isLockerOrder !== true &&
          this.countryCode !== 'CY') ||
        (this.rating < 9 && this.confirmedSend === true && this.isLockerOrder === true)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    hasFinishedReviewing: function(newVal) {
      if (newVal === true) {
        this.postReview();
      }
    },
  },
  mounted() {
    this.handleResize(); // Call handleResize once for the initial value
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    onRatingHover(rating) {
      if (rating === null) {
        this.hoveredRating = null;
      } else {
        this.hoveredRating = +rating;
      }
    },
    handleResize() {
      this.isLargeScreen = window.innerWidth > 450; // Adjust the breakpoint as needed
    },

    setRating(rating) {
      this.rating = +rating;
    },

    confirmRating() {
      this.confirmedRating = true;
    },

    confirmTipSelection() {
      this.confirmedTipSelection = true;
    },
    onFeedback(value) {
      this.reviewFeedback = value;
      if (this.isLockerOrder === true && this.reviewOption === '') {
        if (this.rating < 9) {
          this.reviewOption = value;
        } else {
          this.reviewOption = 'favorite experience';
        }
      }
      if (
        this.isLockerOrder === true &&
        (this.reviewFeedback === 'more time in' || this.reviewFeedback !== this.reviewOption)
      ) {
        this.confirmedSend = true;
      }
    },
    onFeedbackComment() {
      this.reviewFeedback = this.reviewFeedback + ': ' + this.feedbackMessage;
      this.confirmedSend = true;
    },

    postReview() {
      if (this.hasFinishedReviewing === true) {
        const body = {
          reviewOption: this.reviewOption,
          rating: this.rating,
          feedback: this.reviewFeedback,
        };
        axios
          .post(
            `${process.env.VUE_APP_COURIER_API}/user/review/${this.voucher}`,
            // `http://localhost:8000/user/review/${this.voucher}`,
            body,
          )
          .catch(err =>
            console.error({
              status: err?.response?.status,
              message: err.response?.data?.error_description,
            }),
          );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.review-title {
  height: 50px;
  line-height: 34px;
  margin-bottom: 16px;
  font-weight: 500;
  font-size: 26px;
  width: 490px;
  letter-spacing: 0px;
}

.button-container {
  margin-top: 46px;
  margin-bottom: 16px;
  margin-left: auto;
}

.star-title {
  height: 30px;
  line-height: 30px;
  margin-top: 70px;
  margin-bottom: 25px;
  font-weight: 500;
  font-size: 22px;
  width: 490px;
  letter-spacing: 0px;
}

textarea {
  border-radius: 10px;
  height: 15vh;
  width: 45%;
  resize: none;
  margin-top: 20px;

  &::placeholder {
    opacity: 0.6;
  }

  &:hover,
  &:focus,
  &:active {
    border-color: #f68b24;

    &::placeholder {
      opacity: 0.4;
    }
  }
}

// Base button styles
button {
  border-radius: 15px;
  border: none;
  color: #ffffff;
  text-align: center;
  transition: all 0.5s;
  cursor: pointer;
  margin-top: 20px;
  margin-right: 25px;
  vertical-align: top;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  &:disabled {
    background-color: #d3d3d3;
    pointer-events: none;
    cursor: not-allowed;
  }

  &:hover span {
    padding-right: 25px;

    &:after {
      opacity: 1;
      right: 0;
    }
  }
}

// Common button styles for .button-next, .feedback-button, and .button-no
.button-next,
.feedback-button,
.button-no {
  width: 180px;
  height: 80px;
  min-height: 80px;
  white-space: normal;
  word-wrap: break-word;
  padding: 8px 12px;
  overflow: hidden;
  line-height: 1.2;
  font-size: 14px;

  span {
    padding: 0 !important;
    line-height: inherit;
    white-space: normal;
    word-wrap: break-word;
    text-align: center;
    display: block;
    font-size: inherit;
  }
}

.button-next {
  background-color: #51b74a;

  span:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    top: 8px;
    right: -20px;
    transition: 0.2s;
  }
}

.button-no {
  background-color: #eb2e2b;

  span:after {
    content: '\2715';
    position: absolute;
    opacity: 0;
    top: 8px;
    right: -20px;
    transition: 0.2s;
  }
}

button span {
  cursor: pointer;
  padding-top: 8px;
  padding-bottom: 8px;
  display: inline-block;
  position: relative;
  transition: 0.2s;
}

.rating-container {
  display: flex;
  gap: 10px;
  font-size: 24px;
}

.circle {
  border-radius: 50%;
  background-color: #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover,
  &.selected {
    background-color: #f68b24;
  }
}

.rating-explanation {
  padding-top: 10px;
  padding-left: 10px;
  font-size: 18px;
  font-weight: 400;
  position: absolute;
}

.bold-text {
  font-weight: bold;
}

.indent {
  display: inline-block;
  margin-left: 20px;
}

// Mobile styles
@media (max-width: 733px) {
  .review-title {
    line-height: 29px;
    height: 46px;
    font-size: 19px;
    width: 328px;
  }

  .star-title {
    font-size: 18px;
    margin-top: 35px;
    margin-bottom: 15px;
    height: 30px;
    width: 328px;
    line-height: 1.3;
  }

  .star-title.feedback-text {
    height: auto; // Only apply auto height when text needs to wrap
  }

  button {
    font-size: 16px;
  }

  textarea {
    width: 95%;
    margin-top: 20px;
  }
}

@media only screen and (max-width: 768px) {
  button {
    font-size: 24px;
    width: 180px;
    margin-top: 20px;
    border-radius: 15px;
  }

  .button-next,
  .feedback-button,
  .button-no {
    width: 160px;
    height: 70px;
    min-height: 70px;
    font-size: 14px;
    margin-right: 15px;
    padding: 6px 10px;
    line-height: 1.1;
  }

  .circle {
    width: 20px;
    height: 20px;
    font-size: 14px;
  }
}

// Desktop styles
@media only screen and (min-width: 769px) {
  button {
    font-size: 24px;
    width: 180px;
    height: 80px;
    margin-top: 40px;
    border-radius: 20px;
    padding: 8px 12px;
  }

  .button-next,
  .feedback-button,
  .button-no {
    font-size: 16px;
    line-height: 1.1;

    span {
      font-size: 14px;
      line-height: 1.1;
    }
  }

  .circle {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
}
</style>
